/**
 * Single source of truth for the setup guide — keep in sync with backend heuristics in
 * `onboardingChecklist.ts` (same step ids).
 */
export interface OnboardingStepMeta {
  id: string;
  link: string;
  optional?: boolean;
}

export const ONBOARDING_STEPS: OnboardingStepMeta[] = [
  { id: 'marina_details', link: '/widget' },
  { id: 'season_dates', link: '/widget' },
  { id: 'berths', link: '/berths' },
  { id: 'pricing', link: '/pricing' },
  { id: 'knowledge', link: '/knowledge' },
  { id: 'widget_embed', link: '/widget' },
  { id: 'stripe', link: '/settings?tab=payments', optional: true },
];

export function isOnboardingStepDone(
  stepId: string,
  detected: Record<string, boolean>,
  manual: Record<string, boolean>,
): boolean {
  return Boolean(detected[stepId] || manual[stepId]);
}

/** “Complete” = all non-optional steps (Stripe excluded). */
export function isOnboardingRequiredComplete(
  detected: Record<string, boolean>,
  manual: Record<string, boolean>,
): boolean {
  return ONBOARDING_STEPS.filter((s) => !s.optional).every((s) =>
    isOnboardingStepDone(s.id, detected, manual),
  );
}
